<template>
  <div class="mt-2">
    <v-data-table
      :headers="headers"
      :items="guaranteesList"
      item-key="id"
      :single-expand="true"
      show-expand
    >
      <template v-slot:item.sitesOfGuarantee="{ item }">
        <div class="d-flex flex-column my-1">
          <div>
            <v-icon small color="blue" class="mr-2">mdi-account</v-icon>
            <span>{{item.beneficiaryName}}</span>
          </div>
          <div>
            <v-icon small color="orange" class="mr-2">mdi-cash</v-icon>
            <span>{{item.obligorName}}</span>
          </div>
          <div>
            <v-icon small color="success" class="mr-2">mdi-shield-account</v-icon>
            <span>{{item.guarantorName}}</span>
          </div>
        </div>
      </template>
      <template v-slot:item.expiryDate="{ item }">
        {{ item.expiryDate | formatDate }}
      </template>
      <template v-slot:item.securedAmount="{ item }">
        {{ item.securedAmountCents | formatCurrency({ key: getCurrencyKeyForItem(item) }) }}
      </template>
      <template v-slot:item.status="{ item }">
        <div class="">
          <v-chip
            :color="statusesMap[item.status] ? statusesMap[item.status].color : ''"
            small
          >{{statusesMap[item.status] ? statusesMap[item.status].name : ''}}</v-chip>
        </div>
      </template>
      <template v-slot:item.document="{ item }">
        <v-btn
          v-if="item.document && item.document.url"
          icon
          small
          :href="item.document.url"
          target="_blank"
        >
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          @click="$emit('EDIT_VARIATION', item)"
          :disabled="!canUserEdit"
        >
          <v-icon>mdi-pencil </v-icon>
        </v-btn>
        <SubmitButton
          icon="mdi-delete"
          small
          :disabled="!!item.amountAssignedToApplication || !canUserEdit || !!item.variationId"
          @click="handleDelete(item)"
        />
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length" class="ma-1">
          <GuaranteeDetails :guarantee="item" :contract="contract" @FETCH_DATA="$emit('FETCH_DATA')" />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SITES } from '@/helpers'
import { deleteGuarantee } from '../../services'

export default {
  name: 'GuaranteesTable',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    site: String,
    contract: Object
  },
  data () {
    return { }
  },
  computed: {
    ...mapState({
      statusesMap: (state) => state.statuses
        .filter(i => i.show.includes('guarantee'))
        .reduce((acc, curr) => ({ ...acc, [curr.code]: curr }), {}),
      canUserEdit: state => state.userPermissionsToContract.canUserEdit
    }),
    guaranteesList () {
      return this.items
    },
    headers () {
      return [
        this.site === SITES.contractor ? { text: this.$t('guarantees.headers.number'), value: 'no' } : null,
        { text: this.$t('common.name'), value: 'name', class: 'max-width-column' },
        { text: this.$t('guarantees.headers.sitesOfGuarantee'), value: 'sitesOfGuarantee', class: 'nowrap' },
        { text: this.$t('guarantees.headers.expiryDate'), value: 'expiryDate', class: 'nowrap' },
        { text: this.$t('guarantees.headers.securedAmount'), value: 'securedAmount', class: 'nowrap' },
        { text: this.$t('guarantees.headers.status'), value: 'status', class: 'nowrap' },
        { text: this.$t('guarantees.headers.document'), value: 'document', class: 'nowrap' },
        { text: '', value: 'actions', sortable: false, width: 120 },
        { text: '', value: 'data-table-expand' }
      ].filter(i => !!i)
    }
  },
  methods: {
    handleDelete (item) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        options: { maxWidth: 650 },
        scope: {
          message: this.$t('common.deleteConfirm', { name: item.name })
        },
        handlers: {
          yes: async () => {
            await deleteGuarantee(this.contract.id, item)
            this.$emit('FETCH_DATA')
          }
        }
      })
    },
    getCurrencyKeyForItem (item) {
      const part = this.contract.parts.find(p => p.id === item.partId)
      return item.partId ? part.currency : ''
    }
  }
}
</script>

<style>
.max-width-column {
  max-width: 100px
}
</style>
